import type { StaleChange } from '@/lib/stale-write';

/**
 * What a store save returns: ok, or the reason it failed. The caller shows the reason where the
 * change was made (a toast, or inside the dialog), so a failed save never replaces the page.
 * `fields` carries the server's per-field messages, for a form to show under its inputs; `stale`
 * is set when someone else saved first (409 `<DOMAIN>_STALE`), for DataChangedBanner.
 */
export type MutationResult<T extends object = object> =
  | ({ ok: true } & T)
  | { ok: false; error: string; code?: string; fields?: Record<string, string>; stale?: StaleChange | null };

/** A thrown error's message, or the fallback when it has none. */
export function errorText(e: unknown, fallback: string): string {
  return e instanceof Error && e.message ? e.message : fallback;
}
